var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarecraftActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.2004C1 15.2004 3.7 8.00039 11 8.70039C18.3 9.40039 19.5 10.0004 20.2 9.20039C21 8.20039 19.8 7.20039 19.8 7.20039C19.8 7.20039 23.3 7.00039 23 9.80039C22.7 12.0004 19.9 12.2004 18.9 12.0004C16.2 11.5004 11.7 10.1004 9.2 10.2004C6.4 10.3004 4.2 10.4004 1 15.2004Z",
    fill: "#BA43B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40002 13.2996C3.40002 13.2996 5.80002 10.5996 9.20002 10.7996C10.7 10.8996 13.2 11.6996 15.8 12.9996C17.7 13.9996 19 13.5996 19 13.5996C19 13.5996 18.1 15.5996 15.6 15.5996C12.9 15.4996 9.40002 9.39965 3.40002 13.2996Z",
    fill: "#BA43B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79999 16.3008C1.79999 16.3008 3.29999 12.8008 6.79999 12.8008C9.69999 12.8008 12.3 16.6008 14.2 16.5008C14.2 16.5008 13.3 17.2008 11.8 17.2008C9.69999 17.2008 7.49999 14.4008 5.29999 14.4008C3.19999 14.4008 1.79999 16.3008 1.79999 16.3008Z",
    fill: "#BA43B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarecraftActive);
export default __webpack_public_path__ + "static/media/carecraft-active.6de1f06ac150dec32d9cf268af509df9.svg";
export { ForwardRef as ReactComponent };